// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1D8H9","label":"Completed_label__3GDSM"};